import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfigEntities } from "src/app/core/models/config-entities";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { MatDialog } from "@angular/material/dialog";
import { ThemeConfigComponent } from "../theme-config/theme-config.component";
import { map } from "rxjs";

@Component({
  selector: "app-configurator-left-panel",
  templateUrl: "./configurator-left-panel.component.html",
  styleUrls: ["./configurator-left-panel.component.scss"],
})
export class ConfiguratorLeftPanelComponent implements OnInit {
  selectedIdx = 0;
  clickedEntity: string = "Overview";
  configEntities: ConfigEntities[];
  @ViewChild("content", { static: true }) content: TemplateRef<any>;

  constructor(
    private router: Router,
    private configEntityService: ConfigEntityService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private _dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.navService.index.subscribe((x) => (this.selectedIdx = x));
    this.configEntityService.getAllConfigEntities()
      .pipe(
        map(data => this.sortEntitiesAlphabetically(data))
      )
      .subscribe({
        next: (data) => {
          this.configEntities = JSON.parse(JSON.stringify(data));
          this.arrangeArray();
        },
        error : (error) => {
          console.error("Error: ", error);  
        }
      });
   this.router.events.subscribe(() => {
      const currentRoute = this.router.url.split("/")[1];  
      this.clickedEntity = currentRoute || "Overview"; 
    });
    this.navService.selectedLogType = "AllLogs";
  }

  arrangeArray() {
    let length = this.configEntities.length - 1;
    let lastIndex = this.configEntities[length];
    this.configEntities.unshift(lastIndex);
    this.configEntities.pop();
  }

  onConfigClick( name: string) {
    this.clickedEntity = name;
    this.configEntityService.sendActiveEntity(this.clickedEntity);
    this.router.navigate([`/Configurator/${name}`]); 
  }

  sortEntitiesAlphabetically(data: any) {
    return data.sort((a, b) => {
      if (a.name < b.name) {
        return -1; 
      } else if (a.name > b.name) {
        return 1; 
      } else {
        return 0;
      }
    });
  }
}
